<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bkht">
<h1 class="bkht"><a class="page" id="pi"></a>Unfreedom</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0001.vue?0edc6a9d